// fbPath.js
import { collection, doc } from "firebase/firestore";
import { db } from "../../../firebase";

// join like ["missions","abc","comments"] → collection(db,"missions","abc","comments")
export const colAt = (...segments) => collection(db, ...segments);
// join like ["missions","abc"] → doc(db,"missions","abc")
export const docAt = (...segments) => doc(db, ...segments);

// convenience: append segments to a basePath array
export const withBase = (basePath, ...rest) => [...basePath, ...rest];
